import "core-js/modules/es.array.push.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-14195c79"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left fontCoarse"
}, "时间", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "胜"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "平"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "负"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_5 = {
  class: "left fontCoarse"
};
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = {
  class: "u-batNum"
};
const _hoisted_8 = {
  key: 0,
  class: "u-img"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_sjt.png"
}, null, -1));
const _hoisted_10 = [_hoisted_9];
const _hoisted_11 = {
  key: 1,
  class: "u-img"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_xjt.png"
}, null, -1));
const _hoisted_13 = [_hoisted_12];
const _hoisted_14 = {
  key: 2,
  class: "u-img"
};
const _hoisted_15 = {
  class: "content"
};
const _hoisted_16 = {
  class: "u-batNum"
};
const _hoisted_17 = {
  key: 0,
  class: "u-img"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_sjt.png"
}, null, -1));
const _hoisted_19 = [_hoisted_18];
const _hoisted_20 = {
  key: 1,
  class: "u-img"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_xjt.png"
}, null, -1));
const _hoisted_22 = [_hoisted_21];
const _hoisted_23 = {
  key: 2,
  class: "u-img"
};
const _hoisted_24 = {
  class: "content"
};
const _hoisted_25 = {
  class: "u-batNum"
};
const _hoisted_26 = {
  key: 0,
  class: "u-img"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_sjt.png"
}, null, -1));
const _hoisted_28 = [_hoisted_27];
const _hoisted_29 = {
  key: 1,
  class: "u-img"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_xjt.png"
}, null, -1));
const _hoisted_31 = [_hoisted_30];
const _hoisted_32 = {
  key: 2,
  class: "u-img"
};
import { ref } from 'vue';
export default {
  __name: 'HadView',
  setup(__props, {
    expose: __expose
  }) {
    const hadList = ref([]);
    const changeList = ref([]);
    const pushHadList = list => {
      hadList.value = list;
      if (list.length > 0) {
        let initHad = list[0];
        let lastHad = list[list.length - 1];
        let change = [];
        let hf = 0;
        let df = 0;
        let af = 0;
        change.push({
          name: "初始:" + initHad.updateTime,
          h: initHad.h,
          d: initHad.d,
          a: initHad.a,
          hf: hf,
          df: df,
          af: af
        });
        hf = parseFloat(initHad.h) > parseFloat(lastHad.h) ? -1 : parseFloat(initHad.h) < parseFloat(lastHad.h) ? 1 : 0;
        df = parseFloat(initHad.d) > parseFloat(lastHad.d) ? -1 : parseFloat(initHad.d) < parseFloat(lastHad.d) ? 1 : 0;
        af = parseFloat(initHad.a) > parseFloat(lastHad.a) ? -1 : parseFloat(initHad.a) < parseFloat(lastHad.a) ? 1 : 0;
        change.push({
          name: "最新:" + lastHad.updateTime,
          h: lastHad.h,
          d: lastHad.d,
          a: lastHad.a,
          hf: hf,
          df: df,
          af: af
        });
        changeList.value = change;
      }
    };
    // 暴露给外部使用的函数
    __expose({
      pushHadList
    });
    return (_ctx, _cache) => {
      const _component_nut_divider = _resolveComponent("nut-divider");
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_nut_row = _resolveComponent("nut-row");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_nut_divider, {
        "content-position": "left"
      }, {
        default: _withCtx(() => [_createTextVNode("胜平负")]),
        _: 1
      }), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 9
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(changeList.value, (change, index) => {
        return _openBlock(), _createBlock(_component_nut_row, {
          key: index
        }, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 9
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_5, _toDisplayString(change.name), 1)]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(change.h), 1), change.hf == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_8, _hoisted_10)) : change.hf == -1 ? (_openBlock(), _createElementBlock("span", _hoisted_11, _hoisted_13)) : (_openBlock(), _createElementBlock("span", _hoisted_14))])]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString(change.d), 1), change.df == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_17, _hoisted_19)) : change.df == -1 ? (_openBlock(), _createElementBlock("span", _hoisted_20, _hoisted_22)) : (_openBlock(), _createElementBlock("span", _hoisted_23))])]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createElementVNode("span", _hoisted_25, _toDisplayString(change.a), 1), change.af == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_26, _hoisted_28)) : change.af == -1 ? (_openBlock(), _createElementBlock("span", _hoisted_29, _hoisted_31)) : (_openBlock(), _createElementBlock("span", _hoisted_32))])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024);
      }), 128))], 64);
    };
  }
};